import MasterCrudPage from "../../components/MasterCrudPage";
import {
  advertisementApi,
  locationApi,
  serviceApi,
} from "../../api/masterApi";

function selectedNames(ids, options) {
  const selected = new Set((ids || []).map(String));
  return options
    .filter((option) => selected.has(String(option.value)))
    .map((option) => option.label)
    .join(", ");
}

export default function Advertisement() {
  return (
    <MasterCrudPage
      title="Advertisement Master"
      description="Create advertisements and assign them to assets and locations."
      idKey="advertisement_id"
      api={advertisementApi}
      listLabel="advertisements"
      loadExtraOptions={async () => {
        const [assets, locations] = await Promise.all([
          serviceApi.list(),
          locationApi.list(),
        ]);

        const assetOptions = assets.map((asset) => ({
          value: asset.service_id,
          label: asset.service_title,
        }));
        const locationOptions = locations.map((location) => ({
          value: location.location_id,
          label: location.location_name,
        }));

        return {
          assets: assetOptions,
          locations: locationOptions,
        };
      }}
      fields={[
        {
          name: "advertisement_title",
          label: "Advertisement Title",
          type: "text",
          required: true,
          placeholder: "Enter advertisement title",
        },
        {
          name: "advertisement_text",
          label: "Advertisement Text",
          type: "textarea",
          fullWidth: true,
          placeholder: "Enter advertisement text",
        },
        {
          name: "discount",
          label: "Discount",
          type: "number",
          min: 0,
          step: "0.01",
        },
        {
          name: "sort_order",
          label: "Sort Order",
          type: "number",
          min: 0,
          step: "1",
          defaultValue: "0",
        },
        {
          name: "start_date",
          label: "Start Date",
          type: "date",
        },
        {
          name: "end_date",
          label: "End Date",
          type: "date",
        },
        {
          name: "linked_asset_ids",
          label: "Linked Assets",
          type: "multiselect",
          optionsKey: "assets",
          fullWidth: true,
        },
        {
          name: "location_ids",
          label: "Locations",
          type: "multiselect",
          optionsKey: "locations",
          fullWidth: true,
        },
        {
          name: "advertisement_image",
          label: "Advertisement Image",
          type: "image",
          accept: "image/*",
        },
      ]}
      columns={[
        { key: "advertisement_id", label: "Advertisement" },
        { key: "advertisement_title", label: "Title" },
        { key: "advertisement_text", label: "Text" },
        { key: "discount", label: "Discount" },
        {
          key: "linked_asset_ids",
          label: "Linked Assets",
          render: (item, options) =>
            selectedNames(item.linked_asset_ids, options.assets || []) || "—",
        },
        {
          key: "advertisement_image",
          label: "Image",
          type: "image",
        },
        { key: "sort_order", label: "Sort Order" },
        { key: "start_date", label: "Start Date" },
        { key: "end_date", label: "End Date" },
        {
          key: "location_ids",
          label: "Locations",
          render: (item, options) =>
            selectedNames(item.location_ids, options.locations || []) || "—",
        },
      ]}
    />
  );
}
